// extracted by mini-css-extract-plugin
export default {"hotWords":"index_hotWords_2XwXR","title":"index_title_l2qH7","btnWp":"index_btnWp_qlSYl","btn":"index_btn_j3TY3","shake":"index_shake_5SHzA","logo":"index_logo_1EUSM"};